// src/components/room/RoomChatSection.jsx
import React, { useRef, useEffect } from 'react';

export default function RoomChatSection({ 
  messages, chatInput, replyTo, isMinimized, isFullscreen, 
  fullscreenChatOpen, width, onWidthChange, onMinimizeToggle, 
  onClose, onInputChange, onSend, onReplyCancel, onReplyClick,
  onFullscreenChatToggle, onResizeStart
}) {
  const chatContainerRef = useRef(null);

  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [messages]);

  if (isMinimized) {
    return (
      <div className="chat-section minimized" style={{ width: '50px' }}>
        <div className="chat-minimized" onClick={onMinimizeToggle}>
          <span className="minimized-icon">💬</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="chat-resize-handle" onMouseDown={onResizeStart}>
        {isFullscreen && !isMinimized && (
          <button className="fullscreen-chat-toggle" onClick={(e) => {
            e.stopPropagation();
            onFullscreenChatToggle();
          }}>
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              {fullscreenChatOpen ? 
                <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/> : 
                <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
              }
            </svg>
          </button>
        )}
        <div className="resize-dots"><span>⋮</span></div>
      </div>
      <div className={`chat-section ${isMinimized?'minimized':''} ${isFullscreen&&!fullscreenChatOpen?'hidden':''}`} style={{width:isMinimized?'50px':`${width}px`}}>
        <div className="chat-container">
          {isMinimized ? (
            <div className="chat-minimized" onClick={onMinimizeToggle}><span className="minimized-icon">💬</span></div>
          ) : (
            <>
              <div className="chat-header">
                <h3>Room Chat</h3>
                <div className="chat-header-actions">
                  <button className="btn-header-action" onClick={onMinimizeToggle}>─</button>
                  <button className="btn-header-action" onClick={onClose}>✕</button>
                </div>
              </div>
              <div className="chat-messages" ref={chatContainerRef}>
                {messages.map((msg,i)=>(
                  <div key={i} className={`chat-message ${msg.isMine?'mine':'other'}`}>
                    <div className="message-sender">{msg.isMine?'You':msg.senderName}</div>
                    <div className="message-text">
                      {msg.replyTo && (
                        <div className="reply-reference">
                          <span className="reply-name">{msg.replyTo.senderName}</span>
                          <span className="reply-text-preview">{msg.replyTo.text}</span>
                        </div>
                      )}
                      {msg.text}
                    </div>
                    <div className="message-time">
                      {new Date(msg.sentAt).toLocaleTimeString([],{hour:'2-digit',minute:'2-digit'})}
                      <button className="btn-reply" onClick={() => onReplyClick(msg)} title="Reply">↩</button>
                    </div>
                  </div>
                ))}
              </div>
              <div className="chat-input-area">
                {replyTo && (
                  <div className="reply-preview">
                    <div className="reply-preview-header">
                      <span>Replying to <strong>{replyTo.senderName}</strong></span>
                      <button className="reply-cancel" onClick={onReplyCancel}>✕</button>
                    </div>
                    <div className="reply-preview-text">{replyTo.text}</div>
                  </div>
                )}
                <input 
                  className="chat-input" 
                  placeholder="Type a message..." 
                  value={chatInput} 
                  onChange={onInputChange} 
                  onKeyPress={e=>e.key==='Enter'&&onSend()} 
                />
                <button className="btn btn-send" onClick={onSend} disabled={!chatInput.trim()}>Send</button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}